module.exports = __webpack_public_path__ + "media/images/talent/mv-slider07-6e4fee94132a91f68c2e9f21bd97269f.png";